<template>
  <div class="whitespace-nowrap" :class="{ 'text-danger': !isResultUnder }">
    <span>{{ resultTag }}<span v-if="!tableMode">:</span></span>
    <span class="minutes-label"
      ><minutes-label
        :minutes="displayTime"
        :not-available="notAvailable"
        :default-text="defaultText"
        :not-available-text="notAvailableText"
    /></span>
  </div>
</template>

<script>
import { isFalsy } from "@/lib/helpers.js";

import MinutesLabel from "@/components/MinutesLabel.vue";

export default {
  components: {
    MinutesLabel
  },
  props: {
    minutes: {
      type: Number,
      default: 0
    },
    notAvailable: {
      type: Boolean,
      default: false
    },
    tableMode: {
      type: Boolean,
      default: false
    },
    defaultText: {
      type: String,
      default: ""
    },
    notAvailableText: {
      type: String,
      default: ""
    }
  },
  computed: {
    displayTime() {
      //minutes needs to know if is negative or positive
      //for display the sign is giving by the dynamic label
      return !isFalsy(this.minutes) ? Math.abs(this.minutes) : null;
    },
    isResultUnder() {
      return !this.minutes || this.minutes <= 0;
    },
    resultTag() {
      if (this.tableMode && (this.notAvailable || isFalsy(this.minutes))) {
        return "";
      }
      return this.isResultUnder ? "Under" : "Over";
    }
  }
};
</script>

<style lang="scss" scoped>
.minutes-label {
  display: inline-block;
}
</style>
